import React from 'react'
import { Col, Form, Row, Typography } from 'antd'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'

import { Button, Drawer } from 'src/components/Ant'
import { Input, SelectResource, SelectStatus } from 'src/components/Formik'
import { Option } from 'src/components/Formik/Select'

import * as CSS from './styles'
import validationSchema from './validation-schema'

import * as Values from '../initial-values'

interface EmailNotificationsDrawerProps {
  handleSubmit: (values: any) => void
  refFormik: React.MutableRefObject<any>
  isLoading: boolean
}

const options: Option[] = [
  {
    label: 'common.status.unified.approval_pending',
    value: 'APPROVAL_PENDING'
  },
  {
    label: 'common.status.unified.approval_reproved',
    value: 'APPROVAL_REPROVED'
  },
  {
    label: 'common.status.unified.underway',
    value: 'UNDERWAY'
  },
  {
    label: 'common.status.unified.conference_pending',
    value: 'CONFERENCE_PENDING'
  },
  {
    label: 'common.status.unified.conference_reproved',
    value: 'CONFERENCE_REPROVED'
  },
  {
    label: 'common.status.unified.closing_pending',
    value: 'CLOSING_PENDING'
  },
  {
    label: 'common.status.unified.closing_reproved',
    value: 'CLOSING_REPROVED'
  },
  {
    label: 'common.status.unified.canceled',
    value: 'CANCELED'
  },
  {
    label: 'common.status.unified.finished',
    value: 'FINISHED'
  }
]

export default function EmailNotificationsDrawer({
  handleSubmit,
  isLoading,
  refFormik
}: EmailNotificationsDrawerProps) {
  const { t } = useTranslation()

  return (
    <Formik
      initialValues={Values.initialValues}
      onSubmit={handleSubmit}
      ref={refFormik}
      render={formikProps => (
        <Drawer
          footer={
            <CSS.DrawerFooterDiv>
              <Button
                loading={isLoading}
                onClick={() => {
                  formikProps.resetForm(Values.initialValues)
                }}
                title="common.actions.cancel"
                type="default"
              />
              <CSS.Button
                loading={isLoading}
                onClick={() => {
                  formikProps.submitForm()
                }}
                title="common.actions.save"
                type="primary"
              />
            </CSS.DrawerFooterDiv>
          }
          onClose={() => {
            formikProps.resetForm(Values.initialValues)
          }}
          title={
            typeof formikProps.values?.user_email_notification_id === 'number'
              ? t('common.actions.edit')
              : t('common.actions.new')
          }
          visible={Boolean(formikProps.values?.user_email_notification_id)}
          width={800}
        >
          <Form onSubmit={formikProps.handleSubmit}>
            <Row gutter={24}>
              <Col span={8}>
                <SelectStatus
                  defaultActiveFirstOption
                  formikProps={formikProps}
                  label="web.user-email-notification.situation-drawer"
                  mode="default"
                  name="notification_status"
                  options={options}
                />
              </Col>
              <Col span={16}>
                <Input
                  formikProps={formikProps}
                  label="web.user-email-notification.email"
                  name="email"
                  placeholder="web.user-email-notification.email-placeholder"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <div>
                  <Typography.Text strong>
                    {t('web.user-email-notification.validate-reason-drawer')}
                  </Typography.Text>
                  <CSS.SwitchContainer>
                    <CSS.Switch
                      checkedChildren={t('common.actions.yes')}
                      formikProps={formikProps}
                      name="validate_reason"
                      required
                      unCheckedChildren={t('common.actions.no')}
                    />
                    <CSS.TextInfo>
                      {t(
                        'web.user-email-notification.validate-reason-drawer-info'
                      )}
                    </CSS.TextInfo>
                  </CSS.SwitchContainer>
                </div>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <SelectResource
                  defaultActiveFirstOption
                  // disabled={!formikProps.values.validate_reason}
                  formikProps={formikProps}
                  keyLabel="name"
                  keyValue="reason_id"
                  label="web.resources.reasons.title"
                  name="reason_id"
                  resource="reasons"
                  style={{ width: '100%' }}
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Typography.Text strong>
                  {t('web.user-email-notification.attach-travel-report')}
                </Typography.Text>
                <CSS.SwitchContainer>
                  <CSS.Switch
                    checkedChildren={t('common.actions.yes')}
                    formikProps={formikProps}
                    name="attach_travel_report"
                    required
                    unCheckedChildren={t('common.actions.no')}
                  />
                  <CSS.TextInfo>
                    {t(
                      'web.user-email-notification.attach-travel-report-drawer-info'
                    )}
                  </CSS.TextInfo>
                </CSS.SwitchContainer>
              </Col>
            </Row>
          </Form>
        </Drawer>
      )}
      validationSchema={validationSchema}
    />
  )
}
